import { render } from "./ImplantsRejectionPosibility.vue?vue&type=template&id=2b7d541e"
import script from "./ImplantsRejectionPosibility.vue?vue&type=script&lang=js"
export * from "./ImplantsRejectionPosibility.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__